let defaultState = {
  bg: 'https://sofive-assets.s3.us-east-1.amazonaws.com/sofive-bg.png',
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'CHANGE_BG':
      return {
        ...state,
        bg: action.bg,
      }
    default:
      return state
  }
}
